import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";

const LanguagesOfTomorrowSection = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const [selected, setSelected] = useState(0);

  const languages = [
    {
      label: "English",
      content: t(
        "ProgramPage.LanguagesOfTomorrowSection.languagesContent.english"
      ),
    },
    {
      label: "Russian",
      content: t(
        "ProgramPage.LanguagesOfTomorrowSection.languagesContent.russian"
      ),
    },
    {
      label: "German",
      content: t(
        "ProgramPage.LanguagesOfTomorrowSection.languagesContent.german"
      ),
    },
  ];

  const handleRedirection = () => {
    const path =
      currentLanguage === "en" ? "/enroll" : `/${currentLanguage}/enroll`;
    history.push(path);
  };

  return (
    <Box sx={{ py: 8, px: 2, textAlign: "center" }}>
      <Typography variant="h2" fontWeight={800} color="text.secondary" mb={4}>
        {t("ProgramPage.LanguagesOfTomorrowSection.title")}
      </Typography>

      <Tabs
        value={selected}
        onChange={(_, newValue) => setSelected(newValue)}
        centered
        textColor="secondary"
        indicatorColor="secondary"
        sx={{
          mb: 3,
          "& .MuiTab-root": {
            fontWeight: 700,
            fontSize: "1.1rem",
            color: "text.primary",
          },
        }}
      >
        {languages.map((lang, i) => (
          <Tab key={lang.label} label={lang.label} />
        ))}
      </Tabs>

      <Box
        sx={{
          maxWidth: 800,
          mx: "auto",
          mb: 4,
          px: 2,
        }}
      >
        <Typography fontSize="1.1rem">{languages[selected].content}</Typography>
      </Box>

      <OrangeHighlightButton onClick={handleRedirection}>
        {t("ProgramPage.LanguagesOfTomorrowSection.buttonText")}
      </OrangeHighlightButton>
    </Box>
  );
};

export default LanguagesOfTomorrowSection;
